import { render } from "./Pegman.vue?vue&type=template&id=6f0c26d9&ts=true"
import script from "./Pegman.vue?vue&type=script&lang=ts"
export * from "./Pegman.vue?vue&type=script&lang=ts"

import "./Pegman.vue?vue&type=style&index=0&id=6f0c26d9&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__